import ExternalAppointmentPage from './ExternalAppointmentPage';

export default ExternalAppointmentPage;
